var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
        _vm._v("该工单是否确认放弃？"),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "内审人员", prop: "nsUser" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择内审人员",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.nsUser,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "nsUser", $$v)
                    },
                    expression: "form.nsUser",
                  },
                },
                _vm._l(_vm.nsOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "放弃原因", prop: "quitReason" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择放弃原因",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.quitReason,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "quitReason", $$v)
                    },
                    expression: "form.quitReason",
                  },
                },
                _vm._l(_vm.quitOptions, function (item) {
                  return _c("el-option", {
                    key: item.seqId,
                    attrs: { label: item.content, value: item.seqId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "小记", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入小记",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.form.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v(" 确 定 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }